export default __webpack_public_path__ + "static/media/icon-inventory-report.5237dbbe.svg";